import React, { useRef, useState } from 'react';
import '../assets/styles/Contact.scss';
// import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';

function Contact() {

    const [name, setName] = useState<string>('');
    const [email, setEmail] = useState<string>('');
    const [message, setMessage] = useState<string>('');

    const [messageThankyou, setMessageThankyou] = useState<boolean>(false);

    const [nameError, setNameError] = useState<boolean>(false);
    const [emailError, setEmailError] = useState<boolean>(false);
    const [messageError, setMessageError] = useState<boolean>(false);

    const form = useRef();

    const sendEmail = async (e: any) => {
        e.preventDefault();

        setNameError(name === '');
        setEmailError(email === '');
        setMessageError(message === '');

        /* Uncomment below if you want to enable the emailJS */

        if (name !== '' && email !== '' && message !== '') {
            var templateParams = {
                name: name,
                email: email,
                message: message
            };

            //console.log(templateParams);

            const currentURL = window.location.href;

            if (currentURL.includes('localhost')) {
                console.log('Running in development environment. Email sending is disabled.');
                setMessageThankyou(true);
            } else {
                const resp = await fetch("https://roclily.dev/contact.php", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        name,
                        email,
                        message,
                    }),
                });

                const data = await resp.json();
                console.log(data);
                if (data.success) {
                    setMessageThankyou(true);
                } else {
                    console.error('Failed to send email:', data);
                }
            }


            setName('');
            setEmail('');
            setMessage('');
            
        }
    };

    return (
        <div id="contact" style={{ backgroundColor: '#f8f9fa'}}>

            <div className="items-container">
                <div className="page-contents">
                    <div className="contact_wrapper">
                        <h1>Contact</h1>
                        <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>
                        <Box
                            ref={form}
                            component="form"
                            noValidate
                            autoComplete="off"
                            className='contact-form'
                        >
                            <div className='form-flex'>
                                <div className='contact-field-container'>
                                    <label>Your Name</label>
                                    <input
                                        className="field"
                                        style={{ color: '#333 !important' }}
                                        required
                                        type="text"
                                        id="outlined-required"
                                        placeholder="What's your name?"
                                        value={name}
                                        onChange={(e) => {
                                            setName(e.target.value);
                                        }}
                                    />
                                </div>
                                <div className='contact-field-container'>
                                    <label>Email Address</label>
                                    <input
                                        className="field"
                                        style={{ color: '#333 !important' }}
                                        required
                                        type="email"
                                        id="outlined-required"
                                        placeholder="How can I reach you?"
                                        value={email}
                                        onChange={(e) => {
                                            setEmail(e.target.value);
                                        }}

                                    />
                                </div>

                            </div>
                            <div className='contact-field-container'>
                                <label>Message</label>
                                <textarea
                                    style={{ color: '#333 !important' }}
                                    required
                                    id="outlined-multiline-static"
                                    placeholder="Send me any inquiries or questions"
                                    rows={10}
                                    className="body-form field"
                                    value={message}
                                    onChange={(e) => {
                                        setMessage(e.target.value);
                                    }}
                                />
                            </div>
                            <Button variant="contained" endIcon={<SendIcon />} onClick={sendEmail}>
                                Send
                            </Button>
                        </Box>
                        { messageThankyou &&
                        <div className={`message-thankyou${messageThankyou ? ' show' : ''}`}>
                            <p>Thank you for reaching out! I'll get back to you as soon as possible.</p>
                        </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Contact;